import { useEffect, useState } from 'react'
import useSWR from 'swr'
import { Single_School } from '@graphql/queries'

const useSchool = (id) => {
  const [school, setSchool] = useState()
  const { data, error, mutate, isValidating } = useSWR(id ? [
    Single_School,
    id,
  ] : null)

  useEffect(() => {
    if (data?.school) setSchool(data.school)
  }, [data, error])

  return {
    school,
    error,
    mutate,
    isValidating,
    isLoading: !error && !data,
  }
}

export { useSchool }
